import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-show-picture-base64-modal',
  templateUrl: './show-picture-base64-modal.component.html',
  styleUrls: ['./show-picture-base64-modal.component.scss']
})
export class ShowPictureBase64ModalComponent implements OnInit {

  @Input() base64! : string;

  constructor(
    readonly activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

}
